// extracted by mini-css-extract-plugin
export var clockwiseSpin = "leavesAnimation-module--clockwiseSpin--954af";
export var counterclockwiseSpinAndFlip = "leavesAnimation-module--counterclockwiseSpinAndFlip--a9ae0";
export var drop = "leavesAnimation-module--drop--50c68";
export var fade = "leavesAnimation-module--fade--a7c9a";
export var leafContWrap = "leavesAnimation-module--leafContWrap--1aeda";
export var leafContainer = "leavesAnimation-module--leafContainer--d82fb";
export var leafImg = "leavesAnimation-module--leafImg--42c78";
export var phone = "leavesAnimation-module--phone--57eb0";